import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../storage/contexts/UserContext";

import FilledButton from "../InterstellrComponents/FilledButton";
import CommonTextField from "../InterstellrComponents/CommonTextField";
import axios from "axios";
import { ADD_SUPPORT_PERSON } from "../Routes";
import { generateURLOptions } from "../URLOptions";

const AddSupportPersonModal = ({ isOpen, onClose, onUpdate }) => {
  const { profile } = useContext(UserContext);

  const [supportCode, setSupportCode] = useState(null);

  const addSupportPerson = async () => {
    try {
      const response = await axios.post(
        ADD_SUPPORT_PERSON,
        {
          code: supportCode,
        },
        {
          headers: generateURLOptions(),
        },
      );

      console.log("Response: ", response.data);
      if (response.data.success == false) {
        return alert(response.data?.message ?? "");
      }

      return onUpdate();
    } catch (error) {
      console.log("Support Person: ", error);
      return alert(error);
    }
  };

  useEffect(() => {
    console.log("USER PROFILE: ", profile);
    if (!isOpen) {
      setSupportCode(null);
    }
  }, [profile, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300">
      <div className="bg-white rounded-xl w-full max-w-sm mx-4 p-6 shadow-xl transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-start">
          <h4 className="text-xl font-semibold text-left mb-2">
            Add a Support Person
          </h4>
          <p className="text-sm text-left text-black mb-2">
            Please enter your Support Person's code to add them as a Nominated
            Support Contact
          </p>

          <CommonTextField
            title={"Support Code"}
            placeholder={"Enter Support Person Code"}
            onChange={setSupportCode}
            value={supportCode}
          />

          <FilledButton
            text={"Add Support Person"}
            onPress={addSupportPerson}
            marginTop={8}
          />

          <button
            onClick={() => {
              onClose();
            }}
            className="w-full text-sm bg-gray-200 text-gray-800 py-2 px-4 rounded-full mt-2 hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSupportPersonModal;
